import { InferOutput, literal, object } from 'valibot'
import { EntityTypeGroupId } from '../../EntityTypeGroupId.enum'
import { entityTypeDefaults, EntityTypeMeta } from '../../EntityTypeMeta'
import { HasXYSchema } from '../../has_xy'
import { HasAnnexPointsSchema } from '../../HasAnnexPoints.type'
import { PlayerIdOrNullSchema } from '../../player/PlayerIdOrNull'
import { BaseEntitySchema } from '../BaseEntity'
import { EntityIdSchema } from '../EntityId.type'
import { EntityLayerId } from '../EntityLayerId/EntityLayerId.enum'
import { EntityTypeId } from '../EntityTypeId.enum'

const entDefaults = {
  etype_id: EntityTypeId.HQ,
  layer_id: EntityLayerId.TerrainL2,
  ap: 20,
  ap_ent_id: null,
} as const

export const HQEntitySchema = object({
  ...BaseEntitySchema.entries,
  etype_id: literal(EntityTypeId.HQ),
  layer_id: literal(EntityLayerId.TerrainL2),
  id: EntityIdSchema,
  ...HasXYSchema.entries,
  player_id: PlayerIdOrNullSchema,
  ...HasAnnexPointsSchema.entries,
})
export type HQEntity = InferOutput<typeof HQEntitySchema>

/**
 * Central command center that serves as the primary base of operations for a military force.
 */
export const HQEntityTypeMeta: EntityTypeMeta = {
  ...entityTypeDefaults,
  // h: 2 * BASE_TILE_SIZE,
  id: EntityTypeId.HQ,
  dname: 'HQ',
  layer_id: EntityLayerId.TerrainL2,
  group_id: EntityTypeGroupId.Property,
  defense: 4, // maybe should be a bonus for owner only
  income: 10,
  resupplies: true,
  entDefaults,
}

export function createHQEntity(
  id: number,
  x: number,
  y: number,
  player_id: number | null
): HQEntity {
  return {
    ...entDefaults,
    heading: 0,
    id,
    x,
    y,
    player_id,
  }
}
